const PageOption = [
    { value: 10, label: '10 / Page' },
    { value: 20, label: '20 / Page' },
    { value: 100, label: '100 / Page' },
    { value: 200, label: '200 / Page' },
  ]

export default PageOption